export default "__VITE_ASSET__76a6ad0f__"